<template>
  <div class="panel-body">
    <v-dialog
      v-if="this.selected != null && this.selected.length > 0"
      persistent
      v-model="dialog1"
      max-width="1000px"
    >
      <rule
        ref="ruleRef"
        eager
        :activeTab="this.userRulesTab"
        :rules="selected[0]"
        :key="ruleKey"
        :user="user"
        @close-rule="dialog1= false"
      ></rule>

    </v-dialog>

    <v-dialog
      v-if="this.selected != null && this.selected.length > 0"
      persistent
      v-model="dialog2"
      max-width="1000px"
    >

      <jar
        ref="jarRef"
        eager
        :activeTab="this.jarTab"
        :jar="selected[0]"
        :key="jarKey"
        :user="user"
        @close-jar="dialog2 = false"
        @fundsadded-jar="fundsAdded"
        v-on:open-rule="openRule($event)"
      ></jar>
    </v-dialog>

    <template>
      <v-form>
        <v-container>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-flex>
          <v-radio-group v-model="activeRadios" row :mandatory="true" @change="staticFilter">
            <v-radio label="All" value="all"></v-radio>
            <v-radio label="Active" value="active"></v-radio>
            <v-radio label="Inactive" value="inactive"></v-radio>
          </v-radio-group>
        </v-container>
      </v-form>
      <v-card>
        <v-data-table
          a
          :headers="headers"
          :items="filteredRules"
          :search="search"
          :loading="loadingRules"
          item-key="ruleId"
          class="elevation-1"
          :rows-per-page="rowsPerPage"
          :items-per-page-options="rppItems"
          @click:row="selectRule($event)"
        >

        <template v-slot:item.ruleTypeId="{item}">
          <span>{{ formatRuleType(item.ruleTypeId) }}</span>
        </template>
        <template v-slot:item.ruleActionTypeId="{item}">
          <span>{{ formatRuleActionType(item.ruleActionTypeId) }}</span>
        </template>
        <template v-slot:item.startDate="{item}">
          <span>{{ formatDate(item.startDate) }}</span>
        </template>
        <template v-slot:item.endDate="{item}">
          <span>{{ formatDate(item.endDate) }}</span>
        </template>
        <template v-slot:item.skipUntilDate="{item}">
          <span>{{ formatDate(item.skipUntilDate) }}</span>
        </template>

          <template v-slot:item.action="{ item }">
            <v-menu>
              <template v-slot:activator="{ on }">
                <!-- <v-btn dark icon>
                  <v-icon small @click="selectJar(item)">visibility</v-icon>
                </v-btn>-->
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="selectRule(item)">
                  <v-list-item-title>Rule Details</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectJar(item)">
                  <v-list-item-title>Jar Details</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <template slot="no-data"></template>
  </div>
</template>

<script>
import rule from '@/components/Rules.vue'
import jar from '@/components/Jar.vue'
import moment from 'moment'

let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loadingRules: false,
    search: '',
    model: null,
    activeRulesFilter: false,
    userRulesTab: 0,
    jarTab: 0,
    jarKey: 0,
    ruleKey: 0,
    rppItems: [
      5,
      20,
      40,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 5,
    ruleRef: null,
    selected: [],
    dialog1: false,
    dialog2: false,
    headers: [
      {
        text: 'Rule ID',
        align: 'left',
        sortable: false,
        value: 'userSelectedRuleId'
      },
      { text: 'Jar ID', value: 'targetJarId' },
      { text: 'Type', value: 'ruleTypeId' },
      { text: 'Action Type', value: 'ruleActionTypeId' },
      { text: 'Amount', value: 'amount' },
      { text: 'Start Date', value: 'startDate' },
      { text: 'End Date', value: 'endDate' },
      { text: 'Max Skips', value: 'maxSkips' },
      { text: 'Skip Until', value: 'skipUntilDate' },
      { text: 'Active', value: 'active' },
      { text: '', width: '5%', value: 'action', sortable: false }
    ],
    rules: [],
    filteredRules: [],
    jar: [],
    activeRadios: 'all',
    ruleActionTypes: {
      1: 'Round up',
      2: 'Percentage',
      3: 'Set amount'
    },
    ruleTypes: {
      1: 'Merchant',
      2: 'Deposit',
      3: 'Budget',
      4: 'Monthly',
      5: 'System - Deposit source',
      6: 'System - Merchant frequency',
      7: 'System - Merchant spend',
      8: 'System - Categorization',
      9: 'Manual',
      10: 'Daily',
      11: 'Weekly',
      12: 'Fitness',
      13: 'Sports',
      14: 'Challenge',
      15: 'Unused',
      16: 'Biweekly'
    }
  }),

  components: {
    rule,
    jar
  },
  created () {
    this.loadRules()
    this.loadJars()
  },
  methods: {
    async loadRules () {
      if (
        this.user === undefined ||
        this.user.userId == null ||
        this.user.userId === ''
      ) {
        // console.log('User ID not set, unable to load rules')
        this.rules = []
        return
      }
      this.loadingRules = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_RULES}/rules?username=${this.user.quberUserName}`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      if (getResponse === undefined) {
        this.rules = []
        this.filteredRules = []
        // console.log('Couldnt get username')
      } else {
        this.rules = getResponse.data
        this.filteredRules = this.rules
        // console.log(
        // 'GOT QUBER USERNAME: %s',
        // console.log(JSON.parse(JSON.stringify(getResponse)))
        // )
      }

      this.loadingRules = false
    },
    async loadJars () {
      if (
        this.user === undefined ||
        this.user.userId == null ||
        this.user.userId === ''
      ) {
        // console.log('User ID not set, unable to load jars')
        this.jar = []
        return
      }
      this.loadingJars = true
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_JAR
      }/jars/user/${this.user.userId}?types=default,charity,incentive,incentive-payment`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      if (!getResponse || !getResponse.data) {
        this.jar = []
      } else {
        this.jar = getResponse.data
      }

      this.loadingJars = false
    },
    async fundsAdded () {
      this.loadJars()
    },
    async selectRule (a, tab) {
      this.dialog1 = true
      this.selected = [a]

      // Force re-render the Rule Component
      this.ruleKey++

      if (this.$refs.ruleRef) this.$refs.ruleRef.model = tab
    },
    async selectJar (a, tab) {
      // Find associated jar using targetJarId from rules
      var element1 = this.jar.find(x => x.id === a.targetJarId)

      // Set the Jar props for Jar component
      this.jarTab = tab
      this.dialog2 = true

      // Find associated Jar with targetJarId
      var targetJarId = a.targetJarId
      this.selected = [element1]

      // Force re-render Jar Component
      this.jarKey++

      if (this.$refs.jarRef) this.$refs.jarRef.model = tab
    },
    staticFilter () {
      this.filteredRules = this.rules

      // Active/Inactive rule filtering
      if (this.activeRadios !== 'all') {
        this.filteredRules = this.filteredRules.filter(i => {
          return (this.activeRadios === 'active' && i.active === true) || (this.activeRadios === 'inactive' && i.active === false)
        })
      }
    },
    formatRuleActionType (ruleActionTypeId) {
      return this.ruleActionTypes[ruleActionTypeId]
    },
    formatRuleType (ruleTypeId) {
      return this.ruleTypes[ruleTypeId]
    },
    formatDate (aDate) {
      if (aDate != null) {
        return moment(String(aDate)).format('MM/DD/YYYY hh:mm:ss')
      }
    },
    openRule (a) {
      this.dialog2 = false
      this.selectRule(a, 0)
    }
  }
}
</script>
